import { z } from 'zod'

const outingSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdBy: z.string(),
  description: z.string().nullable(),
  dateIn: z.string().nullable(),
  dateOut: z.string().nullable(),
  people: z.number().nullable(),
  destination: z.string().nullable(),
  createdAt: z.string().optional(),
  updatedAt: z.string().nullable(),
  updatedBy: z.string().nullable().optional(),
})

export const schema = z.object({
  outings: z.array(outingSchema),
})

export type schemaType = z.infer<typeof schema>
